import React from 'react';
import { Row, Col } from 'antd';
import DetailItem from "./../../../../CSIComponents/DetailItem";
import Collapse, {Panel} from '../../../../ui/Collapse';

interface propsTypes {
  dataList: void | any,
}
const EnergyUsageView = (props: propsTypes) => {
  const data = props.dataList?.environmentalimpact?.energyusage?.energyusage || [];
  return (
    <>
      {data.length ?
        <Collapse defaultActiveKey={data.map((_: object, i : number) => i)} multiCollapseButton>
          {data.map((item: { amount: any; powertype: any; uom: any; }, i: number) => {
            return (
              <Panel header={`Energy Usage ${i + 1}`} key={i} style={{ marginBottom: '20px' }}>
                <Row gutter={24}>
                  <Col span={6}>
                    <DetailItem value={item.amount} label='Energy Usage Amount' />
                  </Col>
                  <Col span={6}>
                    <DetailItem value={item.uom} label='Unit of Measure' />
                  </Col>
                  <Col span={6}>
                    <DetailItem value={item.powertype} label='Power Type' />
                  </Col>
                </Row>
              </Panel>
            )
          })}
        </Collapse> : null
      }
    </>
  )
}


export default EnergyUsageView;